import styled from 'styled-components'

import { Link as BaseLink } from 'react-router-dom'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  position: relative;

  width: 100%;
  padding: 16px 24px;

  box-shadow: 0px 0px 10px 0px rgba(117, 117, 117, 0.1);
  border-radius: ${theme.border.mediumRadius};
  border: 1px solid ${theme.colors.gray100};
  background-color: ${theme.colors.white};

  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.gray900};
  width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Detail = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
  width: calc(100% - 20px);

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${theme.colors.green3};
    }
  }
`

const DetailBase = styled.div`
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
`

export const DetailTitle = styled(DetailBase)`
  display: flex;
  color: ${theme.colors.gray500};
`

export const DetailValue = styled(DetailBase)`
  color: ${theme.colors.gray700};
  align-self: flex-start;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  max-height: calc(2 * 1.2em);
  line-height: 1.2;
`

export const Link = styled(BaseLink)`
  margin-top: 8px;

  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.green2};
  text-decoration: none;

  svg {
    width: 10px;
    height: 10px;

    margin-left: 4px;

    path {
      fill: ${theme.colors.green2};
    }
  }
`

export const IconContainer = styled(Link)`
  position: absolute;
  top: 16px;
  right: 16px;

  svg {
    width: 24px;
    height: 24px;

    path {
      fill: ${theme.colors.green2};
    }
  }
`

export const IconTag = styled.div`
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background-color: ${theme.colors.erro};

  position: absolute;
  top: 0;
  right: 0;
`
